import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import Button from "../../components/Button/Button";
import { FaEdit, FaEye, FaSave } from "react-icons/fa";
import ReusableTable from "../../components/Table/Table";
import { getTraitCellContent } from "./traitCellContent";
import "./AssessmentMarkingForm.css";

const AssessmentMarkingForm = ({
  eventInfo,
  is_traits,
  event_marking,
  editableStudentId,
  gradeSchemeName,
  eventParticipants,
  traitChangeHandler,
  handleChange,
  allSubmitHandler,
  ResultViewHandler,
  handleSubmit,
  editStudentMarksHandler,
}) => {
  const renderMarking = (student, studentIndex) => {
    const isLetterOrText =
      eventInfo.grade_scheme.type === "Letters" || eventInfo.grade_scheme.type === "Text";

    if (student.marks_data[0] !== undefined) {
      if (editableStudentId !== student.id) {
        return student.marks_data[0].option_value;
      }
      return isLetterOrText ? (
        <select
          onChange={(event) => handleChange(event, student, studentIndex, "letter")}
          name="option_id"
          className="form-select form-control cursor-pointer"
          data-placeholder="Select organization"
          value={event_marking[studentIndex].option_id || ""}
        >
          <option value="">Options</option>
          {eventInfo.grade_scheme.ScoreOptions.map((Option, opIdx) => (
            <option value={Option.id} key={opIdx}>
              {Option.option_name}
            </option>
          ))}
        </select>
      ) : (
        <Form.Control
          type="text"
          name="option_value"
          onChange={(event) => handleChange(event, student, studentIndex)}
          value={event_marking[studentIndex] ? event_marking[studentIndex].option_value : ""}
        />
      );
    }

    return isLetterOrText ? (
      <select
        onChange={(event) => handleChange(event, student, studentIndex, "letter")}
        name="option_id"
        className="form-select form-control cursor-pointer"
        data-placeholder="Select organization"
      >
        <option value="">Options</option>
        {eventInfo.grade_scheme.ScoreOptions.map((Option, opIdx) => (
          <option value={Option.id} key={opIdx}>
            {Option.option_name}
          </option>
        ))}
      </select>
    ) : (
      <Form.Control
        type="text"
        name="option_value"
        onChange={(event) => handleChange(event, student, studentIndex)}
      />
    );
  };

  const renderRemark = (student, studentIndex) => {
    const isScholasticSelectable =
      eventInfo.evaluation_type.name === "SCHOLASTIC ASSESSMENT" &&
      gradeSchemeName !== "SUBJECT REMARK";

    if (student.marks_data[0] !== undefined) {
      if (editableStudentId !== student.id) {
        return student.marks_data[0].remark;
      }
      return isScholasticSelectable ? (
        <select
          className="form-control select2"
          value={event_marking[studentIndex] ? event_marking[studentIndex].remark : ""}
          onChange={(event) => handleChange(event, student, studentIndex)}
          name="remark"
        >
          <option value="">Select</option>
          <option value="AB">AB</option>
          <option value="ML">ML</option>
          <option value="LL">LL</option>
          <option value="L">L</option>
          <option value="-">-</option>
        </select>
      ) : (
        <Form.Control
          name="remark"
          as="textarea"
          rows={5}
          onChange={(event) => handleChange(event, student, studentIndex)}
          value={event_marking[studentIndex].remark || ""}
        />
      );
    }

    return isScholasticSelectable ? (
      <select
        className="form-control select2"
        onChange={(event) => handleChange(event, student, studentIndex)}
        value={(event_marking[studentIndex] && event_marking[studentIndex].remark) || ""}
        name="remark"
      >
        <option value="">Select</option>
        <option value="AB">AB</option>
        <option value="ML">ML</option>
        <option value="LL">LL</option>
        <option value="-">-</option>
      </select>
    ) : (
      <Form.Control
        name="remark"
        as="textarea"
        rows={3}
        value={event_marking[studentIndex] && event_marking[studentIndex].remark}
        onChange={(event) => handleChange(event, student, studentIndex)}
      />
    );
  };

  const renderActions = (student, studentIndex) => (
    <div className="event-participants-actions">
      {(eventInfo.evaluation_type.name === "GENERAL REMARKS" ||
        eventInfo.evaluation_type.name === "REMARKS") && (
        <span
          className="event-participants-icon-btn"
          title="View"
          onClick={() => ResultViewHandler(student, studentIndex)}
        >
          <FaEye size="16px" />
        </span>
      )}
      {student.marks_data[0] ? (
        editableStudentId === student.id ? (
          <Button
            type="submit"
            variant="success"
            size="sm"
            onClick={(event) => handleSubmit(event, student.id, studentIndex)}
          >
            Update
          </Button>
        ) : (
          student.marks_data &&
          student.marks_data[0].is_approved === 0 && (
            <span
              className="event-participants-icon-btn"
              title="Edit"
              onClick={() => editStudentMarksHandler(student, studentIndex)}
            >
              <FaEdit size="16px" />
            </span>
          )
        )
      ) : (
        <Button
          type="submit"
          variant="success"
          size="sm"
          onClick={(event) => handleSubmit(event, student.id, studentIndex)}
        >
          Save
        </Button>
      )}
    </div>
  );

  const cols = useMemo(() => {
    const baseCols = [
      {
        title: "Admission Number",
        className: "assessment-fixed-col",
        render: (student) => student.id_number,
      },
      {
        title: "Name",
        className: "assessment-fixed-col assessment-fixed-col-name",
        render: (student) => `${student.first_name} ${student.last_name}`,
      },
      {
        title: "RollNo",
        className: "assessment-fixed-col",
        render: (student) => student.roll_no && student.roll_no,
      },
    ];

    const middleCols = is_traits
      ? (eventInfo?.traits || []).map((trait) => ({
          title: trait.subject_trait.name,
          className: "assessment-trait-col",
          render: (student, studentIndex) =>
            getTraitCellContent({
              studentTrait: trait,
              student,
              eventInfo,
              traitChangeHandler,
              editableStudentId,
              studentIndex,
            }),
        }))
      : [
          { title: "Marking", render: renderMarking },
          { title: "Remark", render: renderRemark, className: "assessment-remark-col" },
        ];

    const actionCol = {
      title: "Actions",
      className: "text-center",
      render: renderActions,
    };

    return [...baseCols, ...middleCols, actionCol];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    is_traits,
    eventInfo,
    editableStudentId,
    event_marking,
    gradeSchemeName,
    traitChangeHandler,
    handleChange,
    ResultViewHandler,
    handleSubmit,
    editStudentMarksHandler,
  ]);

  return (
    <form>
      <div className="assessment-marking-table-wrap">
        <ReusableTable
          cols={cols}
          data={eventParticipants || []}
          bordered
          hoverable
          striped
          fixedStartCols={2}
          fixedEndCols={1}
        />
      </div>
      <div className="d-flex justify-content-end mt-1">
        <Button
          type="submit"
          variant="success"
          icon={<FaSave />}
          onClick={(event) => allSubmitHandler(event)}
        >
          Save all
        </Button>
      </div>
    </form>
  );
};

export default AssessmentMarkingForm;
